export default "__VITE_ASSET__CIFyIFhL__"